import React from "react";

const Header = () => {
  return (
    <div className="text-gray-300 font-digital text-5xl py-20">
      Timely{" "}
      <span role="img" aria-label="clock">
        ⏰
      </span>
    </div>
  );
};

export default Header;
